export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const GET_USER_INFO = 'GET_USER_INFO';

export const UPDATE_USER_TOKEN = 'UPDATE_USER_TOKEN';
export const GET_LOGIN_BOX_CLOSE = 'GET_LOGIN_BOX_CLOSE';
export const EMPTY_LOGIN_CLOSE = 'EMPTY_LOGIN_CLOSE';
